import React, { ReactNode } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { Text } from "../text";
import { useTheme, StyleFunction, useThemedStyle } from "../../theme";
import type { ValidationError, ValidationErrorMessage } from "lib";
import { Spacer } from "../spacer";

export function InputControl(props: {
    children: ReactNode;
    description?: ReactNode;
    style?: StyleProp<ViewStyle>;
    error?: ValidationError | string;
}) {
    const theme = useTheme();
    const styles = useThemedStyle(styleFunc);

    let message;
    if (props.error) {
        message =
            typeof props.error === "string"
                ? props.error
                : (props.error as ValidationErrorMessage).message;
    }
    return (
        <View style={[styles.container, props.style]} testID="input-wrapper">
            {props.children}
            {props.error ? (
                <Text
                    style={[
                        styles.error,
                        props.description
                            ? styles.errorWithDescription
                            : undefined,
                    ]}
                    testID={"error:" + message}
                    role="alert"
                >
                    {message}
                </Text>
            ) : null}
            {props.description ? (
                typeof props.description === "string" ? (
                    <Text style={theme.styles.inputDescription}>
                        {props.description}
                    </Text>
                ) : (
                    props.description
                )
            ) : null}
            <Spacer />
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    error: {
        ...theme.fonts.regular,
        ...theme.styles.inputDescription,
        color: theme.colors.error,
        paddingBottom: theme.spacingScale / 2,
    },
    errorWithDescription: {
        paddingBottom: theme.spacingScale / 2,
    },
    container: {
        marginBottom: theme.spacingScale,
    },
});
